// resources/js/src/services/report.api.ts
import { request } from "./api";

export type ReportReason =
  | "spam"
  | "harassment"
  | "fake_account"
  | "inappropriate_content"
  | "hate_speech"
  | "violence"
  | "other";

export type ReportPayload = {
  userId: string; // encrypted id
  reason: ReportReason;
  details?: string;
};

export const reportApi = {
  submit: (payload: ReportPayload) =>
    request<null>("POST", "/community/reports", {
      user_id: payload.userId,
      reason: payload.reason,
      details: payload.details,
    }),
};